import {
  RowNumberDataReport,
  RowNumberDataReportAlignCenter,
} from 'components/TableStyles/TableContentStyles/TableContentStyles'
import {
  DateFormat,
  arrayIntoString,
} from 'modules/Report/CommonFunction/Function.js'
import { title } from 'modules/Report/ExcelHeaderData.js'
import PageContent from 'modules/Report/Partials/CommonTable/PageContent.js'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import WarningMessage from 'utils/WarningMessage'
import { permittedSubEvents } from '../../../../utils/permissionsValidation'
import { serialNo } from '../../CommonFunction/Function'
import { setRolePublished } from '../../action'
const RolesPublished = ({
  cityData,
  cityDetails,
  tierDetails,
  tierData,
  getRolePublishedToCollege,
  rolesPublishedData,
  excelDataForReport,
  corporateData,
}) => {
  const dispatch = useDispatch()
  const [dateError, setDateError] = useState(false)
  const [createdAtEnd, setCreatedAtEnd] = useState('')
  const [createdAtStart, setCreatedAtStart] = useState('')
  const [clearDate, setClearDate] = useState(false)
  const [loading, setLoading] = useState(false)
  const [excelLoading, setExcelLoading] = useState(false)
  const [loadingTier, setLoadingTier] = useState(false)
  const [loadingRole, setLoadingRole] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const [searchTierValue, setSearchTierValue] = useState('')
  const [tierValue, setTierValue] = useState([])
  const [searchCityValue, setSearchCityValue] = useState('')
  const [cityValue, setCityValue] = useState([])
  const [searchRoleValue, setSearchRoleValue] = useState('')
  const [debounced, setDebounced] = useState(() => searchRoleValue)
  const [filterData, setFilterData] = useState({
    tier: '',
    city: '',
    createdAtEnd: '',
    createdAtStart: '',
  })
  const [tooltip, setTooltip] = useState(false)
  const [sortBy, setSortBy] = useState({
    orderBy: 'desc',
    sortName: 'end_date',
  })
  const [isExcel, setIsExcel] = useState('')
  const [excel, setExcel] = useState([])
  const [previousPage, setPreviousPage] = useState('')
  const onPageChange = pageNum => {
    setPreviousPage(currentPage)
    setCurrentPage(pageNum)
  }
  function hasData(obj) {
    for (let key in obj) {
      if (obj.hasOwnProperty(key) && obj[key] !== '') {
        return true
      }
    }
    return false
  }
  useEffect(() => {
    dispatch(setRolePublished())
  }, [])
  useEffect(() => {
    const timeout = setTimeout(() => {
      setDebounced(searchRoleValue)
    }, 1000)
    return () => {
      clearTimeout(timeout)
    }
  }, [searchRoleValue])

  const clearFilter = () => {
    setCityValue([])
    setTierValue([])
    setCreatedAtStart('')
    setCreatedAtEnd('')
    setClearDate(true)
    setSearchRoleValue('')
    setSearchTierValue('')
    setSearchCityValue('')
    setFilterData({ tier: '', city: '', createdAtEnd: '', createdAtStart: '' })
    dispatch(setRolePublished())
  }
  const applyFilter = () => {
    let filterData = {
      tier: arrayIntoString(tierValue),
      city: arrayIntoString(cityValue),
      createdAtStart: createdAtStart,
      createdAtEnd: createdAtEnd,
    }
    if (createdAtStart) {
      if (!createdAtEnd) {
        WarningMessage(
          <>
            Kindly select <q>To Date</q> from Date Range
          </>
        )
      }
    }
    if (createdAtEnd) {
      if (!createdAtStart) {
        WarningMessage(
          <>
            Kindly select <q>From date</q> from Date Range
          </>
        )
      }
    }
    if (createdAtEnd && createdAtStart && !dateError) {
      setFilterData(filterData)
    }
    if (!createdAtEnd && !createdAtStart && !dateError) {
      setFilterData(filterData)
    }
    if (dateError) {
      setTooltip(true)
      WarningMessage(<>Kindly check the error in filter</>)
    }
  }

  useEffect(() => {
    if (dateError) {
      setTooltip(true)
    }
  }, [dateError])
  const tableData = excelDataForReport?.result?.map((item, index) => [
    {
      value: index + 1,
      style: { fill: { patternType: 'solid', fgColor: { rgb: 'FFFF0000' } } },
    },
    {
      value: item.tittle ? item.tittle : '-',
      style: { font: { bold: true } },
    },
    { value: item.end_date ? DateFormat(item.end_date) : '-' },
    { value: item.totalcollege ? Number(item.totalcollege) : '0' },
    { value: item.collegeaccepted ? Number(item.collegeaccepted) : '0' },
    { value: item.collegepending ? Number(item.collegepending) : '0' },
    { value: item.collegerejected ? Number(item.collegerejected) : '0' },
  ])
  const excelData = [{ columns: title, data: tableData }]
  const onSorting = (pagination, row, sorter) => {
    let order = 'desc'
    let sort = sorter.field
    if (sorter.order === 'descend') {
      //
    } else if (sorter.order === 'ascend') {
      order = 'asc'
    } else {
      sort = 'end_date'
    }
    let sortBy = {
      orderBy: order,
      sortName: sort,
    }
    setSortBy(sortBy)
  }
  useEffect(() => {
    if (hasData(filterData)) {
      if (currentPage) {
        if (hasData(filterData))
          getRolePublishedToCollege(
            10,
            currentPage,
            setLoadingRole,
            searchRoleValue,
            filterData,
            sortBy
          )
      }
    }
  }, [currentPage])
  useEffect(() => {
    if (hasData(filterData))
      getRolePublishedToCollege(
        10,
        1,
        setLoadingRole,
        searchRoleValue,
        filterData,
        sortBy
      )
    setCurrentPage(1)
  }, [filterData, debounced, sortBy])

  useEffect(() => {
    let filterData = {
      tier: arrayIntoString(tierValue),
      city: arrayIntoString(cityValue),
      createdAtStart: createdAtStart,
      createdAtEnd: createdAtEnd,
    }

    setTooltip(hasData(filterData))
  }, [tierValue, cityValue, createdAtStart, createdAtEnd, clearDate])

  const columns = [
    {
      title: 'SR. NO',
      dataIndex: 'id',
      align: 'center',
      width: '10%',
      render: (text, record, index) => (
        <RowNumberDataReportAlignCenter>
          {serialNo(index, previousPage, currentPage, loadingRole)}
        </RowNumberDataReportAlignCenter>
      ),
    },
    {
      title: 'Role',
      width: '30%',
      dataIndex: 'lower(b.tittle)',
      sorter: true,
      render: (_, { tittle }) => (
        <RowNumberDataReport>{tittle}</RowNumberDataReport>
      ),
    },
    {
      title: 'Application last Date',
      sorter: true,
      width: '20%',
      dataIndex: 'end_date',
      align: 'center',
      render: (_, { end_date }) => (
        <RowNumberDataReportAlignCenter>
          {DateFormat(end_date)}
        </RowNumberDataReportAlignCenter>
      ),
    },
    {
      title: 'NO.of colleges',
      dataIndex: 'totalcollege',
      width: '15%',
      align: 'center',
      sorter: true,
      render: (_, { totalcollege }) => (
        <RowNumberDataReportAlignCenter>
          {totalcollege}
        </RowNumberDataReportAlignCenter>
      ),
    },
    {
      title: 'colleges Accepted',
      dataIndex: 'collegeaccepted',
      width: '15%',
      align: 'center',
      sorter: true,
      render: (_, { collegeaccepted }) => (
        <RowNumberDataReportAlignCenter>
          {collegeaccepted}
        </RowNumberDataReportAlignCenter>
      ),
    },
    {
      title: 'Pending',
      dataIndex: 'collegepending',
      key: 'tier',
      width: '15%',
      align: 'center',
      sorter: true,
      render: (_, { collegepending }) => (
        <RowNumberDataReportAlignCenter>
          {collegepending}
        </RowNumberDataReportAlignCenter>
      ),
    },
    {
      title: 'Rejected',
      dataIndex: 'collegerejected',
      key: 'drive Number',
      width: '15%',
      align: 'center',
      sorter: true,
      render: (_, { collegerejected }) => (
        <RowNumberDataReportAlignCenter>
          {collegerejected}
        </RowNumberDataReportAlignCenter>
      ),
    },
  ].filter(item => !item.hidden)
  const clickedExcel = data => {
    let excel = true
    getRolePublishedToCollege(
      5000,
      1,
      setExcelLoading,
      searchRoleValue,
      filterData,
      sortBy,
      excel
    )
    setIsExcel(data)
  }
  useEffect(() => {
    if (
      (excelDataForReport?.result && tableData && isExcel == 'excel') ||
      (excelDataForReport?.result && tableData && isExcel == 'pdf')
    ) {
      if (loadingRole) {
        setExcel([])
      } else {
        setExcel(excelData)
      }
    }
  }, [excelDataForReport?.result, loadingRole])
  const handleHover = () => {
    if (rolesPublishedData?.count > 5000) {
      WarningMessage(
        'Note : The Roles Published to College count should not exceed 5,000 for data export.  Apply filters if necessary'
      )
    }
  }
  const FilterData = [
    {
      id: 3,
      headerName: 'Tier',
      searchValue: searchTierValue,
      setSearchValue: setSearchTierValue,
      setValue: setTierValue,
      value: tierValue,
      data: tierData,
      apicall: tierDetails,
      setLoading: setLoadingTier,
      loading: loadingTier,
      valueParam: 'tier',
      labelParam: 'tier',
      divider: false,
      flag: 'RP',
    },
    {
      id: 2,
      headerName: 'City',
      searchValue: searchCityValue,
      setSearchValue: setSearchCityValue,
      value: cityValue,
      setValue: setCityValue,
      data: cityData,
      apicall: cityDetails,
      setLoading: setLoading,
      loading: loading,
      valueParam: 'city',
      labelParam: 'city',
      divider: true,
      flag: 'RP',
    },
    {
      id: 1,
      headerName: 'Date Range',
      setCreatedAtStart: setCreatedAtStart,
      setCreatedAtEnd: setCreatedAtEnd,
      clearDate: setClearDate,
      clear: clearDate,
      flag: 'RP',
    },
  ]
  useEffect(() => {
    setTierValue([])
  }, [])

  const permission = useSelector(state => state?.auth?.permissions)
  const subEvents = permittedSubEvents(
    permission,
    'REPORTS',
    'Roles Published to Colleges'
  )
  return (
    <>
      {' '}
      <PageContent
        corporateName={corporateData?.name}
        flag="RP"
        columnWidths={[30, 72, 40, 40, 35, 35, 35]} // Array of column widths
        columnFontSize={10} // Font size for the column data
        HAlign={[
          'center',
          'left',
          'center',
          'center',
          'center',
          'center',
          'center',
        ]}
        pdfCellWidth={43}
        filterData={FilterData}
        cityData={cityData}
        cityDetails={cityDetails}
        pageHeader="Roles Published To Colleges"
        hasProp={hasData(filterData)}
        column={columns}
        tableData={rolesPublishedData}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        onPageChange={onPageChange}
        setSearchRoleValue={setSearchRoleValue}
        searchRoleValue={searchRoleValue}
        applyFilter={applyFilter}
        clearFilter={clearFilter}
        onChange={onSorting}
        width={'100'}
        loadingRole={loadingRole}
        loading={loading}
        loadingTier={loadingTier}
        tooltip={tooltip}
        handleHover={handleHover}
        clickedExcel={clickedExcel}
        excel={excel}
        isExcel={isExcel}
        setIsExcel={setIsExcel}
        excelLoading={excelLoading}
        createdAtStart={createdAtStart}
        createdAtEnd={createdAtEnd}
        setCreatedAtStart={setCreatedAtStart}
        setCreatedAtEnd={setCreatedAtEnd}
        setDateError={setDateError}
        subEvents={subEvents}
      />
    </>
  )
}
export default RolesPublished
